// -------------------------12--------------------------------------------
import Cup12FlatImageFront from '../assets/products/cups/12/flat/image-front.png';
import Cup12FlatImageTop from '../assets/products/cups/12/flat/image-top.jpg';
import Cup12FlatImageBottom from '../assets/products/cups/12/flat/image-bottom.jpg';
import Cup12FlatImageColor from '../assets/products/cups/12/flat/image-color.jpg';

import Cup12OvalImageFront from '../assets/products/cups/12/oval/image-front.png';
import Cup12OvalImageBottom from '../assets/products/cups/12/oval/image-bottom.jpg';
import Cup12OvalImageColor from '../assets/products/cups/12/oval/image-color.jpg';
import Cup12OvalImageColor2 from '../assets/products/cups/12/oval/image-color-2.jpg';

import Cup12TallImageFront from '../assets/products/cups/12/tall/image-front.png';
import Cup12TallImageTop from '../assets/products/cups/12/tall/image-top.jpg';
import Cup12TallImageBottom from '../assets/products/cups/12/tall/image-bottom.jpg';
import Cup12TallImageColor from '../assets/products/cups/12/tall/image-color.jpg';

// -------------------------14--------------------------------------------
import Cup14FlatImageFront from '../assets/products/cups/14/flat/image-front.png';
import Cup14FlatImageTop from '../assets/products/cups/14/flat/image-top.jpg';
import Cup14FlatImageBottom from '../assets/products/cups/14/flat/image-bottom.jpg';

import Cup14OvalImageFront from '../assets/products/cups/14/oval/image-front.png';
import Cup14OvalImageBottom from '../assets/products/cups/14/oval/image-bottom.jpg';
import Cup14OvalImageColor from '../assets/products/cups/14/oval/image-color.jpg';

import Cup14TallImageFront from '../assets/products/cups/14/tall/image-front.png';
import Cup14TallImageTop from '../assets/products/cups/14/tall/image-top.jpg';
import Cup14TallImageBottom from '../assets/products/cups/14/tall/image-bottom.jpg';

// -------------------------16--------------------------------------------
import Cup16FlatImageFront from '../assets/products/cups/16/flat/image-front.png';
import Cup16FlatImageTop from '../assets/products/cups/16/flat/image-top.jpg';
import Cup16FlatImageBottom from '../assets/products/cups/16/flat/image-bottom.jpg';
import Cup16FlatImageColor from '../assets/products/cups/16/flat/image-color.jpg';

import Cup16OvalImageFront from '../assets/products/cups/16/oval/image-front.png';
import Cup16OvalImageTop from '../assets/products/cups/16/oval/image-top.jpg';
import Cup16OvalImageBottom from '../assets/products/cups/16/oval/image-bottom.jpg';

// -------------------------18--------------------------------------------
import Cup18FlatImageFront from '../assets/products/cups/18/flat/image-front.png';
import Cup18FlatImageTop from '../assets/products/cups/18/flat/image-top.jpg';
import Cup18FlatImageBottom from '../assets/products/cups/18/flat/image-bottom.jpg';

import Cup18OvalImageFront from '../assets/products/cups/18/oval/image-front.png';
import Cup18OvalImageTop from '../assets/products/cups/18/oval/image-top.jpg';
import Cup18OvalImageBottom from '../assets/products/cups/18/oval/image-bottom.jpg';

// -------------------------20--------------------------------------------
import Cup20TallImageFront from '../assets/products/cups/20/tall/image-front.png';
import Cup20TallImageTop from '../assets/products/cups/20/tall/image-top.jpg';
import Cup20TallImageBottom from '../assets/products/cups/20/tall/image-bottom.jpg';
import Cup20TallImageColor from '../assets/products/cups/20/tall/image-color.jpg';

// -------------------------22--------------------------------------------
import Cup22FlatImageFront from '../assets/products/cups/22/flat/image-front.png';
import Cup22FlatImageTop from '../assets/products/cups/22/flat/image-top.jpg';
import Cup22FlatImageBottom from '../assets/products/cups/22/flat/image-bottom.jpg';
import Cup22FlatImageColor from '../assets/products/cups/22/flat/image-color.jpg';

import Cup22OvalImageFront from '../assets/products/cups/22/oval/image-front.png';
import Cup22OvalImageBottom from '../assets/products/cups/22/oval/image-bottom.jpg';
import Cup22OvalImageColor from '../assets/products/cups/22/oval/image-color.jpg';

import Cup22TallImageFront from '../assets/products/cups/22/tall/image-front.png';
import Cup22TallImageTop from '../assets/products/cups/22/tall/image-top.jpg';
import Cup22TallImageBottom from '../assets/products/cups/22/tall/image-bottom.jpg';
import Cup22TallImageColor from '../assets/products/cups/22/tall/image-color.jpg';

// -------------------------Lids--------------------------------------------
import CupLidFlatImageFront from '../assets/products/cup-lids/flat/image-front.jpg';
import CupLidFlatImageTop from '../assets/products/cup-lids/flat/image-top.jpg';
import CupLidFlatImageColor from '../assets/products/cup-lids/flat/image-color.jpg';

import CupLidDomeImageFront from '../assets/products/cup-lids/dome/image-front.jpg';
import CupLidDomeImageTop from '../assets/products/cup-lids/dome/image-top.jpg';
import CupLidDomeImageColor from '../assets/products/cup-lids/dome/image-color.jpg';

import CupLidStrawlessImageFront from '../assets/products/cup-lids/strawless/image-front.jpg';
import CupLidStrawlessImageTop from '../assets/products/cup-lids/strawless/image-top.jpg';
import CupLidStrawlessImageColor from '../assets/products/cup-lids/strawless/image-color.jpg';


export const MENU_ITEMS = [
  {
    label: 'Home',
    link: '/',
  },
  {
    label: 'Products',
    link: '/products',
  },
  {
    label: 'logo'
  },
  {
    label: 'Tentang Kami',
    link: '/about-us',
  },
  {
    label: 'Hubungi Kami',
    // link: '/contact-us',
  },
  {
    label: 'Request for Quotation',
    link: '/request-for-quotation',
  }
]

export const SHOPEE_LINK = 'https://shopee.co.id/';
export const TOKOPEDIA_LINK = 'https://tokopedia.com/';
export const INSTAGRAM_LINK = 'https://instagram.com/';
export const TIKTOK_LINK = 'https://tiktok.com/';

export const MAPS_LINK = 'https://maps.app.goo.gl/xMqQMTgJvtkT6gEJ6';
export const WHATSAPP_LINK = 'https://wa.me/6281181161299';
export const COMPANY_MOBILE_NO = '+6281181161299';
export const COMPANY_MOBILE_NO_2 = '+6281181161299';
export const COMPANY_EMAIL = 'sales@mcup.asia';
export const CAROUSEL_RESPONSIVE_SIZES_LOGO = {
  desktop: {
    breakpoint: { max: 3000, min: 1000 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1000, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  }
};
export const CAROUSEL_RESPONSIVE_SIZES_CHARITY = {
  desktop: {
    breakpoint: { max: 3000, min: 1000 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1000, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  }
};

// PRODUCTS DATABASE
export const PRODUCT_CATEGORIES = ['all-products', 'cups', 'cup-lids', /*'bundles'*/];

export const PRODUCTS = [
  {
    name: '12 Oz',
    image: Cup12OvalImageFront,
    category: 'cups',
    id: '1',
    unit: 'karton',
    variants: [
      {
        name: 'Oval',
        image: Cup12OvalImageFront,
        description: `100% virgin material bahan PP\n
          1 karton = 1000 Cup\n
          produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
          Free delivery Jabodetabek minimum order 220 karton`,
        volume: '350ml',
        diameter: '92/93mm',
        height: '95mm',
        grammage: '7gr',
        imagesList: [
          Cup12OvalImageFront,
          Cup12OvalImageBottom,
          Cup12OvalImageColor,
          Cup12OvalImageColor2
        ],
      },
      {
        name: 'Datar',
        image: Cup12FlatImageFront,
        description: `100% virgin material bahan PP\n
          1 karton = 1000 Cup\n
          produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
          Free delivery Jabodetabek minimum order 220 karton`,
        volume: '350ml',
        diameter: '92/93mm',
        height: '96mm',
        grammage: '7gr',
        imagesList: [
          Cup12FlatImageFront,
          Cup12FlatImageTop,
          Cup12FlatImageBottom,
          Cup12FlatImageColor
        ],
      },
      {
        name: 'Tall',
        image: Cup12TallImageFront,
        description: `100% virgin material bahan PP\n
          1 karton = 1000 Cup\n
          produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
          Free delivery Jabodetabek minimum order 220 karton`,
        volume: '352ml',
        diameter: '92/93mm',
        height: '106mm',
        grammage: '7gr',
        imagesList: [
          Cup12TallImageFront,
          Cup12TallImageTop,
          Cup12TallImageBottom,
          Cup12TallImageColor
        ],
      }
    ]
  },
  {
    name: '14 Oz',
    image: Cup14OvalImageFront,
    category: 'cups',
    id: '2',
    unit: 'karton',
    variants: [
      {
        name: 'Oval',
        image: Cup14OvalImageFront,
        description: `100% virgin material bahan PP\n
          1 karton = 1000 Cup\n
          produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
          Free delivery Jabodetabek minimum order 220 karton`,
        volume: '386ml',
        diameter: '92/93mm',
        height: '105mm',
        grammage: '7gr',
        imagesList: [
          Cup14OvalImageFront,
          Cup14OvalImageBottom,
          Cup14OvalImageColor,
        ],
      },
      {
        name: 'Datar',
        image: Cup14FlatImageFront,
        description: `100% virgin material bahan PP\n
          1 karton = 1000 Cup\n
          produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
          Free delivery Jabodetabek minimum order 220 karton`,
        volume: '405ml',
        diameter: '92/93mm',
        height: '110mm',
        grammage: '7gr',
        imagesList: [
          Cup14FlatImageFront,
          Cup14FlatImageTop,
          Cup14FlatImageBottom,
        ],
      },
      {
        name: 'Tall',
        image: Cup14TallImageFront,
        description: `100% virgin material bahan PP\n
          1 karton = 1000 Cup\n
          produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
          Free delivery Jabodetabek minimum order 220 karton`,
        volume: '445ml',
        diameter: '92/93mm',
        height: '121mm',
        grammage: '7gr',
        imagesList: [
          Cup14TallImageFront,
          Cup14TallImageTop,
          Cup14TallImageBottom,
        ],
      }
    ]
  },
  {
    name: '16 Oz',
    image: Cup16OvalImageFront,
    category: 'cups',
    id: '3',
    unit: 'karton',
    variants: [
      {
        name: 'Oval',
        image: Cup16OvalImageFront,
        description: `100% virgin material bahan PP\n
          1 karton = 1000 Cup\n
          produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
          Free delivery Jabodetabek minimum order 220 karton`,
        volume: '480ml',
        diameter: '92/93mm',
        height: '96mm',
        grammage: '7gr',
        imagesList: [
          Cup16OvalImageFront,
          Cup16OvalImageTop,
          Cup16OvalImageBottom,
        ],
      },
      {
        name: 'Datar',
        image: Cup16FlatImageFront,
        description: `100% virgin material bahan PP\n
          1 karton = 1000 Cup\n
          produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
          Free delivery Jabodetabek minimum order 220 karton`,
        volume: '453ml',
        diameter: '92/93mm',
        height: '125mm',
        grammage: '7gr',
        imagesList: [
          Cup16FlatImageFront,
          Cup16FlatImageTop,
          Cup16FlatImageBottom,
          Cup16FlatImageColor,
        ],
      },
    ]
  },
  {
    name: '18 Oz',
    image: Cup18OvalImageFront,
    category: 'cups',
    id: '4',
    unit: 'karton',
    variants: [
      {
        name: 'Oval',
        image: Cup18OvalImageFront,
        description: `100% virgin material bahan PP\n
          1 karton = 1000 Cup\n
          produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
          Free delivery Jabodetabek minimum order 220 karton`,
        volume: '506ml',
        diameter: '92/93mm',
        height: '134mm',
        grammage: '8gr',
        imagesList: [
          Cup18OvalImageFront,
          Cup18OvalImageTop,
          Cup18OvalImageBottom,
        ],
      },
      {
        name: 'Datar',
        image: Cup18FlatImageFront,
        description: `100% virgin material bahan PP\n
          1 karton = 1000 Cup\n
          produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
          Free delivery Jabodetabek minimum order 220 karton`,
        volume: '515ml',
        diameter: '92/93mm',
        height: '135mm',
        grammage: '8gr',
        imagesList: [
          Cup18FlatImageFront,
          Cup18FlatImageTop,
          Cup18FlatImageBottom,
        ],
      },
    ]
  },
  {
    name: '20 Oz',
    image: Cup20TallImageFront,
    category: 'cups',
    id: '5',
    unit: 'karton',
    variants: [
      {
        name: 'Tall',
        image: Cup20TallImageFront,
        description: `100% virgin material bahan PP\n
          1 karton = 1000 Cup\n
          produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
          Free delivery Jabodetabek minimum order 220 karton`,
        volume: '600ml',
        diameter: '92/93mm',
        height: '168mm',
        grammage: '9gr',
        imagesList: [
          Cup20TallImageFront,
          Cup20TallImageTop,
          Cup20TallImageBottom,
          Cup20TallImageColor
        ],
      }
    ]
  },
  {
    name: '22 Oz',
    image: Cup22OvalImageFront,
    category: 'cups',
    id: '6',
    unit: 'karton',
    variants: [
      {
        name: 'Oval',
        image: Cup22OvalImageFront,
        description: `100% virgin material bahan PP\n
          1 karton = 1000 Cup\n
          produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
          Free delivery Jabodetabek minimum order 220 karton`,
        volume: '571ml',
        diameter: '92/93mm',
        height: '156mm',
        grammage: '8gr & 9gr',
        imagesList: [
          Cup22OvalImageFront,
          Cup22OvalImageBottom,
          Cup22OvalImageColor,
        ],
      },
      {
        name: 'Datar',
        image: Cup22FlatImageFront,
        description: `100% virgin material bahan PP\n
          1 karton = 1000 Cup\n
          produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
          Free delivery Jabodetabek minimum order 220 karton`,
        volume: '620ml',
        diameter: '92/93mm',
        height: '154mm',
        grammage: '8gr & 9gr',
        imagesList: [
          Cup22FlatImageFront,
          Cup22FlatImageTop,
          Cup22FlatImageBottom,
          Cup22FlatImageColor
        ],
      },
      {
        name: 'Tall',
        image: Cup22TallImageFront,
        description: `100% virgin material bahan PP\n
          1 karton = 1000 Cup\n
          produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
          Free delivery Jabodetabek minimum order 220 karton`,
        volume: '650ml',
        diameter: '92/93mm',
        height: '178mm',
        grammage: '9.5gr',
        imagesList: [
          Cup22TallImageFront,
          Cup22TallImageTop,
          Cup22TallImageBottom,
          Cup22TallImageColor
        ],
      }
    ]
  },
  {
    name: 'Cup Lid',
    image: CupLidFlatImageFront,
    category: 'cup-lids',
    id: '7',
    unit: 'karton',
    variants: [
      {
        name: 'Flat',
        image: CupLidFlatImageFront,
        description: `100% virgin material bahan PP\n
          1 karton = 1000 Cup\n
          produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
          Free delivery Jabodetabek minimum order 220 karton`,
        diameter: '92mm',
        imagesList: [
          CupLidFlatImageFront,
          CupLidFlatImageTop,
          CupLidFlatImageColor,
        ],
      },
      {
        name: 'Dome',
        image: CupLidDomeImageFront,
        description: `100% virgin material bahan PP\n
          1 karton = 1000 Cup\n
          produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
          Free delivery Jabodetabek minimum order 220 karton`,
        diameter: '92mm',
        imagesList: [
          CupLidDomeImageFront,
          CupLidDomeImageTop,
          CupLidDomeImageColor,
        ],
      },
      {
        name: 'Strawless',
        image: CupLidStrawlessImageFront,
        description: `100% virgin material bahan PP\n
          1 karton = 1000 Cup\n
          produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
          Free delivery Jabodetabek minimum order 220 karton`,
        diameter: '92mm',
        imagesList: [
          CupLidStrawlessImageFront,
          CupLidStrawlessImageTop,
          CupLidStrawlessImageColor,
        ],
      },
    ]
  },
  // {
  //   name: 'Lid 93',
  //   image: PLACEHOLDER_IMAGE,
  //   category: 'cup-lids',
  //   id: '7',
  //   unit: 'karton',
  //   variants: [
  //     {
  //       name: 'Flat',
  //       image: PLACEHOLDER_IMAGE,
  //       description: `100% virgin material bahan PP\n
  //         1 karton = 1000 Cup\n
  //         produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
  //         Free delivery Jabodetabek minimum order 220 karton`,
  //       diameter: '93mm',
  //       imagesList: [
  //         PLACEHOLDER_IMAGE,
  //         PLACEHOLDER_IMAGE2,
  //         PLACEHOLDER_IMAGE3,
  //         PLACEHOLDER_IMAGE4
  //       ],
  //     },
  //     {
  //       name: 'Dome',
  //       image: PLACEHOLDER_IMAGE,
  //       description: `100% virgin material bahan PP\n
  //         1 karton = 1000 Cup\n
  //         produk sekali pakai. Produk tidak cocok untuk  di microwave.\n
  //         Free delivery Jabodetabek minimum order 220 karton`,
  //       diameter: '93mm',
  //       imagesList: [
  //         PLACEHOLDER_IMAGE,
  //         PLACEHOLDER_IMAGE2,
  //         PLACEHOLDER_IMAGE3,
  //         PLACEHOLDER_IMAGE4
  //       ],
  //     },
  //   ]
  // },
]

export const CITIES = [
  'Jakarta',
  'Bogor',
  'Depok',
  'Tangerang',
  'Bekasi',
  'Bandung',
  'Semarang',
  'Surabaya',
  'Yogyakarta',
  'Malang',
  'Medan',
  'Palembang',
  'Makassar',
  'Batam',
  'Bali'
];

export const BUSINESS_INDUSTRIES = [
  'Retail',
  'Food & Beverage',
  'Hospitality',
  'Manufacturing',
  'Healthcare',
  'Education',
  'E-commerce',
  'Event Management',
  'Logistics',
  'Other'
];